/** Canonical agency navigation. Keep client selection and old links in one contract. */
export const AGENCY_PATH = "/app/agency";
export const AGENCY_PLANS_PATH = "/app/agency/plans";
export const AGENCY_TEAM_PATH = "/app/settings";
export const AGENCY_GUIDE_PATH = "/app/support";
export const CLIENT_SELECTION_PATH = "/app/select-client";
export const LIMITED_ACCESS_PATH = "/app/access-limited";

export const CLIENT_TABS = [
  { key: "production", label: "Resumen", group: "Operación" },
  { key: "campaigns", label: "Campañas", group: "Operación" },
  { key: "creations", label: "Creaciones", group: "Operación" },
  { key: "assets", label: "Entregas", group: "Operación" },
  { key: "brand", label: "Marca y memoria", group: "Marca" },
  { key: "plan", label: "Créditos y consumo", group: "Gestión" },
  { key: "access", label: "Accesos", group: "Gestión", adminOnly: true },
];
export const CLIENT_TAB_KEYS = CLIENT_TABS.map(({ key }) => key);
export function normalizeClientTab(tab) {
  const key =
    {
      memory: "brand",
      usage: "plan",
      approvals: "campaigns",
      summary: "production",
      deliveries: "assets",
    }[tab] || tab;
  return CLIENT_TAB_KEYS.includes(key) ? key : "production";
}
export const CLIENT_TOOL_ROUTES = [
  { key: "campaigns", path: "/app/campaigns", label: "Campañas", nav: true },
  {
    key: "studio",
    path: "/app/studio",
    label: "Imágenes y carruseles",
    nav: true,
  },
  { key: "clair", path: "/app/clair-labs", label: "Clip Labs", nav: true },
  {
    key: "production",
    path: "/app/production/projects",
    label: "Proyecto de producción",
  },
  { key: "assets", path: "/app/assets", label: "Biblioteca del cliente" },
  { key: "brand", path: "/app/brand-kit", label: "Identidad de marca" },
  { key: "templates", path: "/app/templates", label: "Plantillas" },
];
export function agencyClientPath(clientId, tab = "production") {
  if (!clientId) return AGENCY_PATH;
  const safeTab = normalizeClientTab(tab);
  const section = { memory: "memory", usage: "usage", approvals: "reviews" }[
    tab
  ];
  return `${AGENCY_PATH}/clients/${encodeURIComponent(clientId)}?tab=${safeTab}${section ? `&section=${section}` : ""}`;
}
export function resolveClientTool(pathname = "") {
  return (
    CLIENT_TOOL_ROUTES.find(
      ({ path }) => pathname === path || pathname.startsWith(`${path}/`),
    ) || null
  );
}
export function isClientToolPath(pathname) {
  return !!resolveClientTool(pathname);
}
export function safeProductionReturnTo(value) {
  if (
    typeof value !== "string" ||
    !value.startsWith("/app/") ||
    value.includes("\\")
  )
    return null;
  try {
    const url = new URL(value, "https://clairads.local");
    if (
      url.origin !== "https://clairads.local" ||
      !isClientToolPath(url.pathname)
    )
      return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
export function clientSelectionPath(destination) {
  const safe = safeProductionReturnTo(destination);
  return safe
    ? `${CLIENT_SELECTION_PATH}?returnTo=${encodeURIComponent(safe)}`
    : CLIENT_SELECTION_PATH;
}
export function isAgencyClientPath(pathname = "") {
  return pathname.startsWith(`${AGENCY_PATH}/clients/`);
}
export function resolveLegacyWorkspacePath(
  pathname,
  { activeClientId, isAgencyAdmin, isAgencyStaff } = {},
) {
  if (!isAgencyStaff) return LIMITED_ACCESS_PATH;
  if (pathname === AGENCY_PLANS_PATH)
    return activeClientId
      ? agencyClientPath(activeClientId, "plan")
      : `${CLIENT_SELECTION_PATH}?tab=plan`;
  if (pathname === "/app/dashboard")
    return activeClientId ? agencyClientPath(activeClientId) : AGENCY_PATH;
  if (pathname === "/app/credits")
    return activeClientId
      ? agencyClientPath(activeClientId, "plan")
      : isAgencyAdmin
        ? `${CLIENT_SELECTION_PATH}?tab=plan`
        : AGENCY_PATH;
  if (pathname === "/app/analytics" || pathname === "/app/monitoring")
    return activeClientId
      ? agencyClientPath(activeClientId, "usage")
      : AGENCY_PATH;
  if (pathname === "/app/campaigns/calendar") return "/app/campaigns";
  const plannerPrefix = "/app/campaigns/planner/";
  if (pathname.startsWith(plannerPrefix)) {
    const id = pathname.slice(plannerPrefix.length).split("/")[0];
    if (!id) return "/app/campaigns";
    try {
      return `/app/campaigns/${encodeURIComponent(decodeURIComponent(id))}`;
    } catch {
      return "/app/campaigns";
    }
  }
  return AGENCY_PATH;
}
